import { paymentsDuckCreator } from 'axl-ducks';
import { getPersonalizationClientEnv } from './duckUtils';

const paymentsDuck = paymentsDuckCreator({
  store: 'payments',
  ...getPersonalizationClientEnv(),
});
export default paymentsDuck;
